module.exports = __webpack_public_path__ + "static/media/lysithea-vonordelia-icon.46ecb7c5.png";